import {XauditModel} from '../xaudit.model';

export class CfgARPaymentMethodModel extends XauditModel{
  PaymentMethodID: string;
  TDOCID: number;
  LOCID: number;
  ItemOrder: number;
  Name: string;
  Description: string;
  isActive: boolean;
  enumARPayementTypeID: string;
  enumARPayementETypeID: string;
  enumARPayementCCTypeID: string;
  ARAccountID: string;
}
